import { BulkAssignComponent } from './../models/bulk-assign-component';
import { ApiHelperService, ApiService } from '../../../../shared/services/api';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { BlobWithFilename } from 'app/shared/models';
import { BulkAddToProject, PropertyPhoto } from '../models';
import { catchError, map } from 'rxjs/operators';
import { BulkPhotoReportSettings } from '../models/bulk-photo-report-settings';
import { HttpErrorResponse } from '@angular/common/http';
import { AnalyticsObjectType, AnalyticsService, AnalyticsUiLocation } from 'app/shared/analytics';

@Injectable()
export class PhotoService {

  endpointUrl: string;

  constructor(private api: ApiService,
    private analyticsService: AnalyticsService,
    { photoServiceUrl }: ApiHelperService ) {
    this.endpointUrl = `${photoServiceUrl}/api/photo`;
  }

  // isNameValid(propertyId: string, planName: string, planId: string) {
  //     const request = {
  //         propertyId: propertyId,
  //         name: planName,
  //         planId: planId
  //     };
  //     return this.api.post(`${this.endpointUrl}/isvalidname`, request)
  //         .map(response => response.data);
  // }

  public getByProperty(propertyId: string) {
    const uri = `${this.endpointUrl}/property/${propertyId}`;
    return this.api.get(uri)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error)));
  }

  public updatePropertyPhoto(photo: PropertyPhoto) {
    return this.api.put(`${this.endpointUrl}/${photo.propertyPhotoId}`, photo)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error)));
  }

  public setAsPrimaryPhoto(propertyComponentId: string, propertyPhotoId: string) {
    return this.api.post(`${this.endpointUrl}/${propertyComponentId}/primary/${propertyPhotoId}`)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error)));
  }

  public deletePropertyPhoto(propertyPhotoId: string) {
    this.analyticsService.photoDeletedEvent(AnalyticsObjectType.Property, AnalyticsUiLocation.Photos);
    return this.api.delete(`${this.endpointUrl}/${propertyPhotoId}`);
  }

  public downloadPropertyPhoto(propertyPhotoId: string): Observable<BlobWithFilename> {
    this.analyticsService.photoDownloadedEvent();
    
    return this.api
      .getBlobWithFilename(`${this.endpointUrl}/download/${propertyPhotoId}`, 'application/octet-stream');
  }

  public bulkAssignPropertyPhotosToComponent(request: BulkAssignComponent) {
    return this.api.post(`${this.endpointUrl}/bulk/assigncomponent`, request)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error)));
  }

  public bulkUpdatePropertyPhotosReportSettings(request: BulkPhotoReportSettings) {
    return this.api.post(`${this.endpointUrl}/bulk/reportsettings`, request)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error)));
  }

  public bulkDeletePropertyPhotos(photoIds: string[]) {
    this.analyticsService.photoDeletedEvent(AnalyticsObjectType.Property, AnalyticsUiLocation.PhotosBulkEdit, photoIds.length);

    const request = {
      propertyPhotoIds: photoIds
    };

    return this.api.post(`${this.endpointUrl}/bulk/delete`, request)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error)));
  }

  public bulkDownloadPropertyPhotos(photoIds: string[]): Observable<BlobWithFilename> {
    this.analyticsService.photoDownloadedEvent(null, photoIds.length);
    
    const request = {
      propertyPhotoIds: photoIds
    };
    return this.api
      .postBlobWithFilename(`${this.endpointUrl}/bulk/download`, request, 'application/octet-stream');
  }

  public bulkAddPhotosToProject(request: BulkAddToProject) {
    return this.api.post(`${this.endpointUrl}/bulk/addproject`, request)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error)));
  }

  public removePhotoFromProject(projectId: string, propertyPhotoId: string) {
    return this.api.delete(`${this.endpointUrl}/photo/${propertyPhotoId}/project/${projectId}`)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error)));
  }


  private handleError(response: HttpErrorResponse) {
    return throwError(response?.error?.errors);
  }
}
